<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Email Newsletter', route: '/backoffice/newsletter/' }, { label: 'Modifica Email Newsletter', active: true }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formNewsletter" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <div>
                <h2>Email</h2>
                <span class="ac-meta">indirizzo iscrizione newsletter</span>
            </div>
        </div>

        <div class="fld">
            <label>* Email</label>
            <input type="email" pInputText class="w-full" placeholder="Email" formControlName="email" name="email" id="email" required />
            @if (formNewsletter.get('email')?.hasError('required') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)) {
                <small class="text-red-600 block mt-2 font-medium">L'email è obbligatoria.</small>
            }
            @if (formNewsletter.get('email')?.hasError('email') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)) {
                <small class="text-red-600 block mt-2 font-medium">L'email deve essere valida.</small>
            }
        </div>

        <div class="acc-actions">
            <button class="acc-btn acc-btn-ghost" type="button" (click)="onDeleteNewsletterPopup($event)">Elimina email</button>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formNewsletter.valid">Modifica email</button>
        </div>

        <p-confirmPopup #confirmDeletePopupRef>
            <ng-template pTemplate="headless" let-message>
                <div class="border-round p-3">
                    <span class="text-base">{{ message.message }}</span>
                    <div class="flex align-items-center gap-2 mt-3">
                        <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                    </div>
                </div>
            </ng-template>
        </p-confirmPopup>
    </form>
</section>
